import type { PropsWithChildren } from 'react';
import { MantineProvider } from '@mantine/core';

import { AuthModalsContextProvider as BaseProvider } from './AuthModalsContext';
import AuthModals from './AuthModals';

function AuthModalsContextProvider({ children }: PropsWithChildren) {
  return (
    <BaseProvider>
      {children}
      <MantineProvider inherit theme={{ colorScheme: 'light', globalStyles: undefined }}>
        <AuthModals />
      </MantineProvider>
    </BaseProvider>
  );
}

export default AuthModalsContextProvider;
